<template>
  <div class="container p-1:mo p-y-4 m-b-4:mo">
    <h1 class="h1 m-0 m-b-4">FAQ</h1>
    <div
        v-for="(section, title) in FAQ"
        :key="title"
        class="SECTIONS">
      <h2 class="h4 m-0">{{ title }}</h2>
      <div
          v-for="item in section"
          :key="item.question"
          class="FAQ">
        <div
            class="QUESTION-ROW"
            selenium="question"
            @click="questionClick(item)">
          <span class="flex-1-1 select-none h6">
            {{ item.question }}
          </span>
          <vk-icon
              :class="{ 'ROTATED': expandedId === item.id }"
              class="BUTTON"
              name="close"
              selenium="toggle-button"/>
        </div>
        <div
            v-if="expandedId === item.id"
            class="text-lg c-gray70 m-t-1 m-l-3 m-r-6"
            selenium="answer"
            v-html="item.answer"/>
      </div>
    </div>
    <div class="text-center">
      Still have questions? Email us at
      <a class="link" @click="emailLinkClick">support@proreferral.com</a> or
      call <a class="link" @click="phoneLinkClick">1-855-723-2266.</a>
    </div>
  </div>
</template>

<script>
const FAQ_BREAKDOWN = (URL) => {
  return { 'Job Dashboard': [{
    id: 1,
    question: 'What about additional job statuses such as "Customer is not responding"?',
    answer: 'Please submit your status suggestions or general feedback at <a href="https://www.proreferral.com">ProReferral.com</a>. On the right side of the page, click the orange "Feedback" tab, then choose "General Feedback." Your feedback counts!',
  }],
  'Mobile App Update': [
    {
      id: 2,
      question: 'How can I tell if I have the newest version of the Pro Referral mobile app?',
      answer: 'Sign in to your current Pro Referral app. The newest version has a green toggle labeled "Leads" in the top right corner. If you don\'t see it, go to the Google Play or Apple App store to download and install the most current version.',
    },
    {
      id: 3,
      question: 'I notice the new app does not include an area for notes or appointments.',
      answer: 'You can use the notes feature by signing in to <a href="https://www.proreferral.com">your Pro Referral account on the web</a>. A new appointments feature will be released in the near future.',
    },
  ],
  'Compliance Updates': [
    {
      id: 4,
      question: 'Why is the background check process different than it used to be?',
      answer: 'Our customers have told us that Pros who have passed background checks and ID verification have given them peace of mind when selecting the right contractor. We\'ve updated our background check process to ensure both you and the homeowner feel comfortable about connecting on home projects.',
    },
    {
      id: 5,
      question: 'Does the background check cost money?',
      answer: 'Your background check and ID verification cost $39.99 and is good for two years. 100% of that cost is paid directly to Checkr, a secure third-party processor.',
    },
    {
      id: 6,
      question: 'How long does the background check take?',
      answer: 'Your background check is typically returned to us in fewer than five days. It some instances, it may take longer depending on a variety of factors such as processing times in the county(s) you do business in. You’ll receive an email as soon as your background check is completed.',
    },
    {
      id: 7,
      question: 'What if I’ve completed a background check elsewhere, may I use it instead?',
      answer: 'Unfortunately, no. In order to be a Pro with Pro Referral, you’ll need to complete and pass our specific background check and ID verification requirements.',
    },
    {
      id: 8,
      question: 'What if I don\'t have a trade license and/or the county I do business in doesn’t require one? May I use a business license instead?',
      answer: `Pro Referral validates trade licenses at the state level. In some cases, this may exceed your local requirement. We do not accept business licenses as a substitute. In order to be a part of Pro Referral, you must meet our <a href="${URL}/pro/becomeapro#section-requirements">statewide licensing requirements </a>.`,
    },
    {
      id: 9,
      question: 'Do I still need to carry General Liability insurance if I have homeowner and/or auto insurance?',
      answer: 'Yes. All Pros with Pro Referral need to carry General Liability insurance.',
    },
    {
      id: 10,
      question: 'What happens if I am not able or interested in moving forward with these new compliance requirements?',
      answer: 'In order to keep your Pro Referral account active, you\'ll need to complete our compliance requirements by the due date indicated in your email reminders. If not, your account will become inactive and you won\'t been able to access any new or existing leads. In the event you want to move forward at a later time, we may need to ensure there is still an opening in your area of expertise.',
    },
  ] };
};


export default {
  FAQ_BREAKDOWN,
  name: 'frequenty-asked-questions',
  data () {
    return {
      expandedId: 1,
      FAQ: this.$options.FAQ_BREAKDOWN(this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN),
    };
  },
  methods: {
    questionClick ({ question, id }) {
      if (this.expandedId === id) {
        this.expandedId = null;
      } else {
        this.expandedId = id;
        this.$events.$emit(this.$events.FAQ_VIEWED, {
          id,
          question,
        });
      }
    },
    phoneLinkClick () {
      this.$events.$emit(this.$events.FAQ_PHONE_LINK_CLICKED);
      document.location.href = 'tel:8557232266';
    },
    emailLinkClick () {
      this.$events.$emit(this.$events.FAQ_EMAIL_LINK_CLICKED);
      document.location.href = 'mailto:support@proreferral.com';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  $faq-border: solid 1px $color-gray40;
  $transition-props: 0.25s cubic-bezier(0.4, 0.0, 0.2, 1);

  .SECTIONS {
    @include margin-bottom(4);
    border-bottom: 1px solid $color-gray30;

    &:last-child {
      border-bottom: none; //$faq-border;
    }
  }

  .FAQ {
    @include padding(2);
    @include margin-bottom(1);
    display: flex;
    flex-direction: column;
  }

  .QUESTION-ROW {
    @include text-large;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include tablet {
      @include h6;
    }
  }

  .BUTTON {
    @include margin-left(2);
    color: $color-depot;
    flex: 0 0 auto;
    transition: transform $transition-props;
    transform: rotate(-45deg);
    &.ROTATED {
      transform: rotate(0deg);
    }
  }
</style>
